var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "item-row-quote-builder-labour quote-builder-item-row type-mech",
      class: [
        {
          "is-selected": _vm.isSelected,
          "is-open": _vm.isSelected && !_vm.isFullWidth,
        },
        `quote-builder-item-${_vm.$theme.name}`,
        _vm.defaultRowColourClass(
          _vm.item,
          _vm.getItemAssessments(_vm.item),
          _vm.displayDeleted
        ),
        _vm.rowDisplayStatus(_vm.item, _vm.getItemAssessments(_vm.item)),
      ],
      attrs: { id: _vm.item.quoteItemId },
    },
    [
      _c("quote-builder-other-labour-item-template", {
        attrs: {
          "is-full-width": _vm.isFullWidth,
          "is-quote-hour": _vm.isQuoteTypeHour,
          "is-fully-expanded": _vm.isSelected && !_vm.isFullWidth,
          "is-selected": _vm.isSelected,
          "is-header": false,
        },
        on: { handleClick: _vm.handleClick },
        scopedSlots: _vm._u(
          [
            {
              key: "description",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "focus-next",
                          rawName: "v-focus-next:callback",
                          value: _vm.handleTransitionNextRow,
                          expression: "handleTransitionNextRow",
                          arg: "callback",
                        },
                      ],
                      staticClass: "is-flex",
                      class: [_vm.defaultCellColourClass(_vm.item, "itemDesc")],
                      style: { width: "100%" },
                    },
                    [
                      _vm.isSelected &&
                      !_vm.item.deleteOtherItem &&
                      !_vm.readOnlyComputed &&
                      !_vm.readOnlyView &&
                      !_vm.audanetLock &&
                      !_vm.isItemRemoved(
                        _vm.item,
                        _vm.getItemAssessments(_vm.item)
                      )
                        ? _c("input", {
                            directives: [
                              {
                                name: "focus-next-element-on-arrow-directive",
                                rawName:
                                  "v-focus-next-element-on-arrow-directive:callback",
                                value: _vm.handleArrowKeys,
                                expression: "handleArrowKeys",
                                arg: "callback",
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.item.itemDesc,
                                expression: "item.itemDesc",
                              },
                            ],
                            staticClass: "input",
                            class: [
                              _vm.defaultRowColourClass(
                                _vm.item,
                                _vm.getItemAssessments(_vm.item),
                                false
                              ),
                              !_vm.isValidItemDesc(_vm.item.quoteItemId)
                                ? "is-danger"
                                : "",
                            ],
                            attrs: {
                              placeholder: "Item Description",
                              id: _vm.item.quoteItemId + "-itemDesc",
                            },
                            domProps: { value: _vm.item.itemDesc },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.item,
                                  "itemDesc",
                                  $event.target.value
                                )
                              },
                            },
                          })
                        : _c(
                            "span",
                            {
                              staticClass: "pl-2",
                              class: { "has-text-danger": !_vm.item.itemDesc },
                              attrs: { id: _vm.item.quoteItemId + "-itemDesc" },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.item.itemDesc || "Item Description"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "report",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "is-clickable",
                      class: {
                        disabled:
                          _vm.item.deleteOtherItem ||
                          !_vm.canMakeReportOnly(_vm.item),
                      },
                      on: {
                        click: ($event) => _vm.updateReport(_vm.item, $event),
                      },
                    },
                    [
                      _c("div", { staticClass: "is-flex" }, [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: { theme: "secondary", enabled: true },
                                expression:
                                  "{ theme: 'secondary', enabled: true }",
                              },
                            ],
                            staticClass: "tag p-1 px-2",
                            class: _vm.item.reportOnly
                              ? "is-dark is-danger"
                              : "is-white",
                            attrs: { content: "Report" },
                          },
                          [_vm._v("R ")]
                        ),
                      ]),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "rates",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      class: [
                        { tooltip: _vm.isItemInvoiced(_vm.item) === true },
                      ],
                      attrs: {
                        "data-tooltip": "Item rate is already invoiced!",
                      },
                    },
                    [
                      _vm.isSelected &&
                      !_vm.readOnlyComputed &&
                      !_vm.readOnlyView &&
                      !_vm.audanetLock &&
                      !_vm.isItemRemoved(
                        _vm.item,
                        _vm.getItemAssessments(_vm.item)
                      ) &&
                      !_vm.isItemInvoiced(_vm.item)
                        ? _c("vue-numeric", {
                            directives: [
                              {
                                name: "focus-next",
                                rawName: "v-focus-next:callback",
                                value: _vm.handleTransitionNextRow,
                                expression: "handleTransitionNextRow",
                                arg: "callback",
                              },
                              {
                                name: "focus-next-element-on-arrow-directive",
                                rawName:
                                  "v-focus-next-element-on-arrow-directive:callback",
                                value: _vm.handleArrowKeys,
                                expression: "handleArrowKeys",
                                arg: "callback",
                              },
                            ],
                            staticClass: "input has-text-right skip-tab",
                            class: [
                              _vm.defaultRowColourClass(
                                _vm.item,
                                _vm.getItemAssessments(_vm.item),
                                false
                              ),
                              _vm.item.rate !==
                              _vm.findLabourRate(
                                _vm.item.itemType,
                                _vm.innerValue.rates,
                                _vm.innerValue.shopRate
                              ).rate
                                ? "is-warning"
                                : "",
                            ],
                            attrs: {
                              id: _vm.item.quoteItemId + "-rate",
                              placeholder: "Rate",
                              min: 0,
                              precision: 2,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.onRateChange(_vm.item)
                              },
                            },
                            model: {
                              value: _vm.item.rate,
                              callback: function ($$v) {
                                _vm.$set(_vm.item, "rate", _vm._n($$v))
                              },
                              expression: "item.rate",
                            },
                          })
                        : _c(
                            "div",
                            {
                              staticClass:
                                "is-flex is-justify-content-end is-quote-item-field-editable",
                              attrs: { id: _vm.item.quoteItemId + "-rate" },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      _vm.item.rate,
                                      _vm.$userInfo.locale,
                                      false,
                                      2
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "hour_value",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "is-flex is-justify-content-end" },
                    [
                      _vm.isSelected &&
                      !_vm.readOnlyComputed &&
                      !_vm.readOnlyView &&
                      !_vm.audanetLock &&
                      !_vm.isItemRemoved(
                        _vm.item,
                        _vm.getItemAssessments(_vm.item)
                      )
                        ? _c("vue-numeric", {
                            directives: [
                              {
                                name: "focus-next",
                                rawName: "v-focus-next:callback",
                                value: _vm.handleTransitionNextRow,
                                expression: "handleTransitionNextRow",
                                arg: "callback",
                              },
                              {
                                name: "focus-next-element-on-arrow-directive",
                                rawName:
                                  "v-focus-next-element-on-arrow-directive:callback",
                                value: _vm.handleArrowKeys,
                                expression: "handleArrowKeys",
                                arg: "callback",
                              },
                            ],
                            staticClass: "input has-text-right",
                            class: _vm.defaultRowColourClass(
                              _vm.item,
                              _vm.getItemAssessments(_vm.item),
                              false
                            ),
                            attrs: {
                              id: _vm.item.quoteItemId + "-hourValue",
                              placeholder: "h(s)",
                              minus: true,
                              precision: 2,
                            },
                            on: {
                              blur: function ($event) {
                                return _vm.onRateChange(_vm.item)
                              },
                            },
                            model: {
                              value: _vm.item.hourValue,
                              callback: function ($$v) {
                                _vm.$set(_vm.item, "hourValue", $$v)
                              },
                              expression: "item.hourValue",
                            },
                          })
                        : _vm.isQuoteHour
                        ? _c(
                            "span",
                            {
                              staticClass: "is-quote-item-field-editable",
                              attrs: {
                                id: _vm.item.quoteItemId + "-hourValue",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.item.hourValue?.toFixed(2)) +
                                  " "
                              ),
                            ]
                          )
                        : _c(
                            "span",
                            {
                              staticClass: "is-quote-item-field-editable",
                              attrs: {
                                id: _vm.item.quoteItemId + "-hourValue",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      _vm.item.hourValue,
                                      _vm.$userInfo.locale,
                                      false,
                                      2
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "total_value",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass:
                        "is-flex is-justify-content-end is-align-items-center",
                      class: {
                        "has-text-danger":
                          !_vm.item.dollarValue && !_vm.item.reportOnly,
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$filters.formatCurrency(
                                _vm.item.dollarValue,
                                _vm.$userInfo.locale,
                                false,
                                2
                              )
                            ) +
                            " "
                        ),
                      ]),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "present_as",
              fn: function () {
                return [
                  _c("present-as-component", {
                    attrs: { item: _vm.item },
                    on: {
                      handlePresentAs: function ($event) {
                        !_vm.readOnlyComputed &&
                          _vm.$emit("handlePresentAs", _vm.item)
                      },
                    },
                  }),
                ]
              },
              proxy: true,
            },
            _vm.item.itemComment
              ? {
                  key: "comment",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                theme: "secondary",
                                enabled: true,
                                content: _vm.item.itemComment,
                              },
                              expression:
                                "{ theme: 'secondary', enabled: true, content:item.itemComment }",
                            },
                          ],
                        },
                        [
                          _c("span", {
                            staticClass:
                              "mdi has-text-primary is-primary mdi-18px mdi-message-reply-text mr-1 is-clickable",
                          }),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "assessment_status",
              fn: function () {
                return [
                  (_vm.innerValue.quoteAssessments?.length || 0) > 0
                    ? _c("supplementary-icon", {
                        staticClass: "icon",
                        attrs: {
                          item: _vm.item,
                          "item-assessments": _vm.getItemAssessments(_vm.item),
                          "next-assessment-number": _vm.nextSupplemetryNo,
                          "quoting-method": _vm.innerValue.quotingMethod,
                          "icon-size": 4,
                        },
                      })
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
            !_vm.audanetLock &&
            !_vm.isItemRemoved(_vm.item, _vm.getItemAssessments(_vm.item)) &&
            (_vm.item.isDeleted === false || _vm.item.deleted === false)
              ? {
                  key: "delete",
                  fn: function () {
                    return [
                      _c(
                        "button",
                        {
                          staticClass:
                            "button is-ghost is-small tooltip p-0 mx-1 has has-text-grey-lighter",
                          attrs: {
                            "data-tooltip": "Delete",
                            disabled: _vm.readOnlyComputed,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("deleteItem", _vm.item)
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "material-symbols-rounded",
                              class: { "is-clickable": !_vm.readOnlyComputed },
                              on: {
                                mouseenter: function ($event) {
                                  return $event.target.classList.add(
                                    "has-text-danger"
                                  )
                                },
                                mouseleave: function ($event) {
                                  return $event.target.classList.remove(
                                    "has-text-danger"
                                  )
                                },
                              },
                            },
                            [_vm._v(" delete ")]
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "draggable",
              fn: function () {
                return [
                  _c(
                    "button",
                    {
                      staticClass:
                        "button is-ghost is-small tooltip item-drag-handle px-0 has-text-grey-light",
                      attrs: {
                        "data-tooltip": "Drag",
                        disabled: _vm.readOnlyComputed || _vm.readOnlyView,
                      },
                    },
                    [
                      _c("span", {
                        staticClass: "mdi mdi-drag-vertical mdi-24px",
                        class: { "is-clickable": !_vm.readOnlyComputed },
                      }),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "lineNo",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            theme: "secondary",
                            enabled: true,
                            content: "Line Number",
                          },
                          expression:
                            "{ theme: 'secondary', enabled: true, content: 'Line Number' }",
                        },
                      ],
                    },
                    [
                      !_vm.readOnlyComputed &&
                      _vm.$userInfo.isSupportUser &&
                      !_vm.readOnlyView &&
                      !_vm.isItemRemoved(
                        _vm.item,
                        _vm.getItemAssessments(_vm.item)
                      )
                        ? _c("vue-numeric", {
                            directives: [
                              {
                                name: "focus-next",
                                rawName: "v-focus-next:callback",
                                value: _vm.handleTransitionNextRow,
                                expression: "handleTransitionNextRow",
                                arg: "callback",
                              },
                            ],
                            staticClass: "input has-text-right",
                            class: _vm.defaultRowColourClass(
                              _vm.item,
                              _vm.getItemAssessments(_vm.item),
                              false
                            ),
                            attrs: { precision: 0, separator: "" },
                            model: {
                              value: _vm.item.lineNumber,
                              callback: function ($$v) {
                                _vm.$set(_vm.item, "lineNumber", _vm._n($$v))
                              },
                              expression: "item.lineNumber",
                            },
                          })
                        : _c("span", [_vm._v(_vm._s(_vm.item.lineNumber))]),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "itemNo",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            theme: "secondary",
                            enabled: true,
                            content: "Item Number",
                          },
                          expression:
                            "{ theme: 'secondary', enabled: true, content: 'Item Number' }",
                        },
                      ],
                    },
                    [
                      !_vm.item.deleteOtherItem &&
                      !_vm.readOnlyComputed &&
                      !_vm.readOnlyView &&
                      !_vm.audanetLock &&
                      !_vm.isItemRemoved(
                        _vm.item,
                        _vm.getItemAssessments(_vm.item)
                      )
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.item.itemNo,
                                expression: "item.itemNo",
                              },
                              {
                                name: "focus-next",
                                rawName: "v-focus-next:callback",
                                value: _vm.handleTransitionNextRow,
                                expression: "handleTransitionNextRow",
                                arg: "callback",
                              },
                            ],
                            staticClass: "input",
                            class: [
                              _vm.defaultRowColourClass(
                                _vm.item,
                                _vm.getItemAssessments(_vm.item),
                                false
                              ),
                              !_vm.isValidItemNo(_vm.item.quoteItemId)
                                ? "is-danger"
                                : "",
                            ],
                            attrs: { placeholder: "Item No." },
                            domProps: { value: _vm.item.itemNo },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.item,
                                  "itemNo",
                                  $event.target.value
                                )
                              },
                            },
                          })
                        : _c("span", [_vm._v(_vm._s(_vm.item.itemNo))]),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "itemStatus",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            theme: "secondary",
                            enabled: true,
                            content: "Item Status",
                          },
                          expression:
                            "{ theme: 'secondary', enabled: true, content: 'Item Status' }",
                        },
                      ],
                    },
                    [
                      !_vm.readOnlyComputed &&
                      !_vm.readOnlyView &&
                      !_vm.isItemRemoved(
                        _vm.item,
                        _vm.getItemAssessments(_vm.item)
                      )
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.item.itemStatus,
                                expression: "item.itemStatus",
                              },
                              {
                                name: "focus-next",
                                rawName: "v-focus-next:callback",
                                value: _vm.handleTransitionNextRow,
                                expression: "handleTransitionNextRow",
                                arg: "callback",
                              },
                            ],
                            staticClass: "input is-capitalized",
                            domProps: { value: _vm.item.itemStatus },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.item,
                                  "itemStatus",
                                  $event.target.value
                                )
                              },
                            },
                          })
                        : _c("span", [_vm._v(_vm._s(_vm.item.itemStatus))]),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }